import React, { useEffect, useState } from "react";

import { STRING_NOT_NULL_HELPER } from "../../common/helpersTxt";
import { validateString } from "../../common/validators";

// APP COMPONENTS
import ModalHeader from "../modals/modalHeader";
// MATERIAL UI COMPONENTS
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Backdrop from "@mui/material/Backdrop";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from "@mui/material/styles";
import { fillWithSpecialCharacters } from "../../extras";

const ModalRoot = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  border: "none",
  borderRadius: 12,
  // overflow: 'auto',
  [theme.breakpoints.down("md")]: {
    width: "100% !important",
    height: "95% !important",
    borderRadius: "0 0",
    overflow: "auto",
  },
  [theme.breakpoints.up("md")]: {
    width: "30% !important",
  },
  backgroundColor: "#fff",
  paddingRight: 24,
  paddingLeft: 24,
  paddingBottom: 24,
  paddingTop: 0,
  "&:focus-visible": {
    border: "none",
  },
}));

export default function CreateOrEditPaymentMethodModal({
  paymentMethod,
  show,
  closeModal,
  createPaymentMethod,
  editPaymentMethod,
}) {
  const [loading, setLoading] = useState(false);
  const [paymentMethodName, setPaymentMethodName] = useState(
    paymentMethod ? paymentMethod.title : ""
  );
  const [isPaymentMethodNameValid, setIsPaymentMethodNameValid] =
    useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (paymentMethod) {
      setIsEditing(true);
    }
  }, []);

  const handleSubmit = () => {
    setLoading(true);
    setSubmitted(true);

    const isValid = validateString(paymentMethodName);
    if (!isValid) {
      setIsPaymentMethodNameValid(false);
      return;
    }

    const paymentMethodObj = {
      title: fillWithSpecialCharacters(paymentMethodName),
    };

    if (isEditing) {
      editPaymentMethod(paymentMethodObj);
    } else {
      createPaymentMethod(paymentMethodObj);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", height: "100vh" }}>
        <Stack
          spacing={2}
          sx={{
            m: "auto",
          }}
        >
          <CircularProgress sx={{ "&:focus-visible": { border: "none" } }} />
        </Stack>
      </Box>
    );
  }

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={show}
      onClose={closeModal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      sx={{
        zIndex: 5000,
        "&:focus-visible": {
          border: "none",
        },
      }}
    >
      <Fade in={show}>
        <ModalRoot>
          <ModalHeader
            label="Método de Pagamento"
            margin={0}
            onClose={closeModal}
          />
          <Box
            sx={{
              padding: 6,
            }}
          >
            <TextField
              size="small"
              variant="outlined"
              id="new_paymentMethod_name"
              name="paymentMethod_name"
              label="Nome"
              fullWidth
              required
              error={!isPaymentMethodNameValid && submitted}
              value={paymentMethodName}
              helperText={
                !isPaymentMethodNameValid && submitted
                  ? STRING_NOT_NULL_HELPER
                  : ""
              }
              onChange={(event) => {
                setPaymentMethodName(event.target.value);
              }}
              sx={{ mb: 2 }}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              onClick={handleSubmit}
              sx={{ mt: 4 }}
            >
              {isEditing ? "Atualizar" : "Cadastrar"}
            </Button>
          </Box>
        </ModalRoot>
      </Fade>
    </Modal>
  );
}
